import * as ACTIONTYPE from '../constants/actiontypes'
const _default = {
  isViewTracked: false,
  secondsToNextTimeTrack: 10,
  secondsPerTrack: 10,
  framesPerTrack: 2,
  lastTimeTrackingTime: new Date(),
}

export default function (state = _default, action) {
  switch (action.type) {
    case ACTIONTYPE.CHANGE_SECONDS_TO_NEXT_TIME_TRACK:
      return {
        ...state,
        secondsToNextTimeTrack: action.secondsToNextTimeTrack,
        lastTimeTrackingTime: action.lastTimeTrackingTime,
      };
    case ACTIONTYPE.TRACK_VIEW:
      return {
        ...state,
        isViewTracked: true,
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/TrackingReducer.js